import Main from "./Main";

//=================================================================
//料率調整案件の調整内容の画面クラス
//概要：料率調整案件登録画面の新規登録ボタンから遷移、新規登録を行う
//
//遷移先：このページに来る前の情報更新画面
//戻り先：このページに来る前の情報更新画面
//
//==================================================================

export const Register = () => {
  return <Main />;
};
